// extracted by mini-css-extract-plugin
export default {"snippet":"oSQru1De","tlImageContainer":"tlImageContainer","mobile":"mobile"};